export default __webpack_public_path__ + "static/media/pages.e0355956.svg";